import { ListPageSkeleton, SidePanelSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Creative 素材库页面骨架。
 *
 * 真实结构：`w-full h-full flex overflow-hidden gap-x-5`
 * → 左：`FolderTree`（`w-62` 248px + h-12 标题「素材文件夹」+ 树节点）
 * → 右：`flex flex-col flex-1`，工具栏（标题 / 搜索 InputGroup `w-xs` / 日期范围 `w-60` /
 *   列表-网格切换 / 上传素材 / 上传文件夹）+ `mt-4 flex-1` 内的 `TableCardLayout`
 *   （带素材类型 Tab 头，视频-图片默认 11 列）。
 */
export function MaterialLibrarySkeleton() {
  return (
    <div className="w-full h-full flex overflow-hidden gap-x-5">
      {/* 左侧素材文件夹树 */}
      <SidePanelSkeleton widthClassName="w-62" itemCount={4} itemHeight={32} />

      <div className="flex min-w-0 flex-1 flex-col">
        {/* 工具栏 */}
        <div className="flex flex-row flex-wrap items-center gap-x-2 gap-y-1">
          <Skeleton className="mr-auto h-5.5 w-32" />
          <Skeleton className="h-9 w-xs" />
          <Skeleton className="h-9 w-60" />
          {/* 列表 / 网格切换 */}
          <div className="flex h-auto items-center gap-1 rounded-md bg-muted p-1.25">
            <Skeleton className="size-8 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
            <Skeleton className="size-8 rounded-sm bg-[#e4e4e4] dark:bg-[#3a3a3a]" />
          </div>
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-28" />
        </div>

        {/* 素材列表卡片（实测 12 列：勾选 + 预览/素材名称/尺寸/时长/文件大小/标签/设计师/上传者/上传时间/审核状态/操作） */}
        <div className="mt-4 min-h-0 flex-1 overflow-hidden">
          <ListPageSkeleton withHeaderTabs columnCount={12} />
        </div>
      </div>
    </div>
  );
}

export default MaterialLibrarySkeleton;
